import {
  FETCH_HIELOCOS_SUCCESS,
  FETCH_HIELOCOS_NEXT_PAGE,
  FETCH_HIELOCOS_ERROR,
  DELETE_HIELOCO,
  FETCH_HIELOCOS_START_LOADING,
  FETCH_HIELOCOS_FINISH_LOADING,
  ADD_HIELOCO,
} from '../types/hielocos';
import hielocosService from '../../services/hielocos';
import { notification } from 'antd';

const LOADING_DELAY = 500;

export function fetchHielocos() {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_HIELOCOS_START_LOADING });

      const hielocos = await hielocosService.getAll({ page: 0 });

      dispatch({
        type: FETCH_HIELOCOS_SUCCESS,
        payload: hielocos,
      });

      setTimeout(() => {
        dispatch({
          type: FETCH_HIELOCOS_FINISH_LOADING,
        });
      }, LOADING_DELAY);
    } catch (error) {
      notification.open({
        type: 'error',
        message: error.message,
        placement: 'bottomRight',
      });
      dispatch({ type: FETCH_HIELOCOS_ERROR, payload: { error } });
    }
  };
}

export function fetchHielocosNextPage(currentPage) {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_HIELOCOS_START_LOADING });

      const hielocos = await hielocosService.getAll({ page: currentPage });

      dispatch({
        type: FETCH_HIELOCOS_NEXT_PAGE,
        payload: hielocos,
      });

      setTimeout(() => {
        dispatch({
          type: FETCH_HIELOCOS_FINISH_LOADING,
        });
      }, LOADING_DELAY);
    } catch (error) {
      dispatch({ type: FETCH_HIELOCOS_ERROR, payload: { error } });
    }
  };
}

export function addHieloco(hieloco, local = false) {
  return async (dispatch) => {
    try {
      let res;

      if (!local) {
        res = await hielocosService.createHieloco(hieloco);
      } else {
        res = await hielocosService.createLocalHieloco(hieloco);
      }

      dispatch({
        type: ADD_HIELOCO,
        payload: { hieloco: res.hieloco },
      });

      return Promise.resolve({ message: res.message });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function deleteHieloco(id) {
  return async (dispatch) => {
    try {
      const res = await hielocosService.deleteHieloco(id);

      dispatch({
        type: DELETE_HIELOCO,
        payload: { id },
      });

      return Promise.resolve({ message: res.message });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
